import { gql } from "@apollo/client";

import { ProfileCareerTabRoleFragment } from "@apps/profile/career-tab/graphql/get-profile-career-query";

export default gql`
  ${ProfileCareerTabRoleFragment}
  query getUserRolesDetailsQuery($userId: Int!) {
    user(userId: $userId) {
      id
      name
      firstName
      lastName
      email
      avatar
      isInCurrentUserReportingTree
      currentRoles {
        id
        title
        ...ProfileCareerTabRole
        careerTrack {
          id
          title
        }
      }
      futureRoles {
        id
        title
        ...ProfileCareerTabRole
        careerTrack {
          id
          title
        }
      }
    }
  }
`;
